/**
 * @generated SignedSource<<8d25ca81dd54b6bd701243f62743bc2e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedRelatedSeller_creatorShopLink$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SeoLink_linkData">;
  readonly " $fragmentType": "SbSharedRelatedSeller_creatorShopLink";
};
export type SbSharedRelatedSeller_creatorShopLink$key = {
  readonly " $data"?: SbSharedRelatedSeller_creatorShopLink$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRelatedSeller_creatorShopLink">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRelatedSeller_creatorShopLink",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SeoLink_linkData"
    }
  ],
  "type": "LinkData",
  "abstractKey": null
};

(node as any).hash = "ea0edb2bc82a0e87b3158a3cf3a003e2";

export default node;
